import { useEffect, useState } from "react";
import { Flex, Image, useColorModeValue } from "@chakra-ui/react";
import { COLORS } from "../../constants/COLORS";

interface LoadingOverlayProps {
  isLoaded: boolean;
}

export default function LoadingOverlay({ isLoaded }: LoadingOverlayProps) {
  const [startFadeOut, setStartFadeOut] = useState(false);
  const [hidden, setHidden] = useState(false);
  const bgColor = useColorModeValue(COLORS.WHITE, COLORS.DARK);

  useEffect(() => {
    if (!hidden) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [hidden]);

  useEffect(() => {
    if (isLoaded) {
      const delay = setTimeout(() => {
        setStartFadeOut(true); 
        const hide = setTimeout(() => setHidden(true), 600); 
        return () => clearTimeout(hide);
      }, 900); 
      return () => clearTimeout(delay);
    }
  }, [isLoaded]);

  if (hidden) return null;

  return (
    <Flex
      position="fixed"
      top={0}
      left={0}
      right={0}
      bottom={0}
      w="100vw"
      h="100vh"
      justify="center"
      align="center"
      bg={bgColor}
      zIndex={9999}
      opacity={startFadeOut ? 0 : 1}
      transition="opacity 0.6s ease"
      pointerEvents={startFadeOut ? "none" : "all"}
    >
      <Image
        src="/logo_black.png"
        alt="Loading Logo"
        boxSize="90px"
        sx={{
          transformStyle: "preserve-3d",
          animation: "spin3D 1s linear infinite",
          "@keyframes spin3D": {
            from: { transform: "rotateY(0deg)" },
            to: { transform: "rotateY(360deg)" },
          },
        }}
      />
    </Flex>
  );
}
